exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-message[data-v-dd222a26] {\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 100px;\n}\n", ""]);

// exports
